module.exports = __webpack_public_path__ + "static/ring_of_spell_storing-9906df8db5053705d79fdcad92656228.jpeg";